import React, { useState, useRef, useEffect } from 'react';
import NotificationBell from './NotificationBell';
import { useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import ChangePasswordModal from './ChangePasswordModal';
import './AdminNavbar.css';

const AdminNavbar = ({ onToggleMobileSidebar, mobileSidebarOpen }) => {
  const { user, logout } = useAdminAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showDropdown && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showDropdown]);

  useEffect(() => {
    setShowDropdown(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') setShowDropdown(false);
    };
    if (showDropdown) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [showDropdown]);

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === '/') return 'Dashboard';
    if (path.includes('/trips')) return 'Manage Trips';
    if (path.includes('/bookings')) return 'Bookings';
    if (path.includes('/users')) return 'Users';
    if (path.includes('/hero')) return 'Hero Section';
    return 'Admin';
  };

  return (
    <>
      <nav className="admin-navbar">
        <div className="admin-navbar__left">
          <button className="admin-navbar__mobile-toggle" onClick={onToggleMobileSidebar} aria-label="Toggle sidebar">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              {mobileSidebarOpen ? (
                <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>
              ) : (
                <><line x1="3" y1="7" x2="21" y2="7" /><line x1="3" y1="12" x2="16" y2="12" /><line x1="3" y1="17" x2="21" y2="17" /></>
              )}
            </svg>
          </button>
          <h1 className="admin-navbar__page-title">{getPageTitle()}</h1>
        </div>

        <div className="admin-navbar__right">
          {/* Notification Bell */}
          <NotificationBell />

          {/* User Menu */}
          <div className="admin-navbar__user-menu" ref={dropdownRef}>
            <button className="admin-navbar__user-btn" onClick={() => setShowDropdown(!showDropdown)}>
              <div className="admin-navbar__avatar">
                {user?.name?.charAt(0)?.toUpperCase() || 'A'}
              </div>
              <div className="admin-navbar__user-info">
                <span className="admin-navbar__user-name">{user?.name || 'Admin'}</span>
                <span className="admin-navbar__user-role">{user?.role || 'admin'}</span>
              </div>
              <svg className={`admin-navbar__chevron ${showDropdown ? 'admin-navbar__chevron--open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            {showDropdown && (
              <div className="admin-navbar__dropdown">
                <div className="admin-navbar__dropdown-header">
                  <div className="admin-navbar__dropdown-avatar">
                    {user?.name?.charAt(0)?.toUpperCase() || 'A'}
                  </div>
                  <div>
                    <p className="admin-navbar__dropdown-name">{user?.name}</p>
                    <p className="admin-navbar__dropdown-email">{user?.email}</p>
                    <span className="admin-navbar__dropdown-role">{user?.role}</span>
                  </div>
                </div>
                <div className="admin-navbar__dropdown-divider" />
                <button className="admin-navbar__dropdown-item" onClick={() => { setShowDropdown(false); setShowChangePassword(true); }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                  Change Password
                </button>
                <div className="admin-navbar__dropdown-divider" />
                <button className="admin-navbar__dropdown-item admin-navbar__dropdown-item--danger" onClick={() => { setShowDropdown(false); logout(); }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      <ChangePasswordModal isOpen={showChangePassword} onClose={() => setShowChangePassword(false)} />
    </>
  );
};

export default AdminNavbar;